import React from 'react'
import FormSF from '../../../widgets/form/FormSF'
import ButtonUI from '../../../widgets/action/ButtonUI'

const GSTCollectUI = ({context, account, successMsg, errorList, onSubmit, setErrorList, submitted
  }) =>
  <div>
    <div className='g_m_top_100'><b>GST</b></div>
    <p>Before proceeding please login to your account on the GST portal (https://cbic-gst.gov.in/cbec-portal-ui/) and enable API request for 6 hours . In addition, you will require access to the following phone number(s) to receive OTPs for sharing your GST data for verification of your loan application.</p>

    <FormSF
      context={context}
      buttonLabel='Generate OTP'
      onSubmit={onSubmit}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      busy={submitted}
    >

      {
        account.gstList.map((gst, i) =>
          <div key={i}>
            GSTIN {gst.gstin}, phone {gst.phoneNumber}
          </div>
        )
      }

      <p>OTP(s) will be sent and will be valid for 5 minutes. Once you are ready start the verification process.</p>

      <p className='g_muted g_small'>* We do not store your username and do not access your online account on the GST portal. We use this information onetime to download your GST returns for verification of your loan application.</p>
    </FormSF>
  </div>

export default GSTCollectUI
